var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3228_381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3228_381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.67676 13.3434H16.6768V5.01009H6.67676V13.3434ZM6.67676 15.0101C6.21842 15.0101 5.82606 14.8469 5.49967 14.5205C5.17329 14.1941 5.01009 13.8018 5.01009 13.3434V3.34342C5.01009 2.88509 5.17329 2.49273 5.49967 2.16634C5.82606 1.83995 6.21842 1.67676 6.67676 1.67676H16.6768C17.1351 1.67676 17.5274 1.83995 17.8538 2.16634C18.1802 2.49273 18.3434 2.88509 18.3434 3.34342V13.3434C18.3434 13.8018 18.1802 14.1941 17.8538 14.5205C17.5274 14.8469 17.1351 15.0101 16.6768 15.0101H6.67676ZM3.34342 18.3434C2.88509 18.3434 2.49273 18.1802 2.16634 17.8538C1.83995 17.5274 1.67676 17.1351 1.67676 16.6768V5.01009H3.34342V16.6768H15.0101V18.3434H3.34342Z",
    fill: "#135FC2",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteIcon);
export default __webpack_public_path__ + "static/media/siteIcon.5df7447f44592b464e698cf2eb5f2514.svg";
export { ForwardRef as ReactComponent };